"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RequestInitHandler {
    constructor(logger, settings, method, body) {
        this._settings = settings;
        this._almeRequestTimeout = this._settings.AlmeApiRequestTimeout;
        this._logger = logger;
        this._timeout = setTimeout(() => { }, 0);
        this._controller = new AbortController();
        if (isNaN(this._almeRequestTimeout) || this._almeRequestTimeout < 100) {
            this._logger.warn('Invalid AlmeApiRequestTimeout configuration.  Using default timeout 10000.');
            this._almeRequestTimeout = 10000;
        }
        this.mode = 'cors';
        this.cache = 'no-cache';
        this.credentials = 'same-origin';
        this.headers = {
            'Content-Type': 'application/json',
        };
        this.redirect = 'follow';
        this.referrer = 'no-referrer';
        this.signal = this._controller.signal;
        this.method = method;
        if (body) {
            this.body = body;
        }
    }
    setSignal() {
        this._timeout = setTimeout(() => {
            this._controller.abort();
            this._controller = new AbortController();
        }, this._almeRequestTimeout);
    }
    clearTimeout() {
        if (typeof this._timeout === "number") {
            clearTimeout(this._timeout);
        }
        else {
            clearTimeout(this._timeout);
        }
    }
}
exports.default = RequestInitHandler;
//# sourceMappingURL=RequestInitHandler.js.map